export const GET_RULE_TEMPLATES = "GET_RULE_TEMPLATES";
export const UPDATE_RULE_TEMPLATES = "UPDATE_RULE_TEMPLATES";
export const CREATE_RULE_TEMPLATE = "CREATE_RULE_TEMPLATE";
export const ADD_RULE_TO_RULE_TEMPLATE = "ADD_RULE_TO_RULE_TEMPLATE";